import React from "react";

export const SectionHeading = ({ eyebrow, title, subtitle, center = true, light = false }) => (
  <div className={`${center ? "text-center mx-auto" : ""} max-w-2xl mb-14 lg:mb-16`}>
    <span className={`mk-gold-line mb-6 ${center ? "inline-block" : "block"}`} />
    {eyebrow && <p className="text-xs uppercase tracking-[0.25em] text-[#D4A62A] font-bold mb-3">{eyebrow}</p>}
    <h2 className={`font-serif-display text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight ${light ? "text-white" : "text-[#0A2E4D]"}`}>{title}</h2>
    {subtitle && <p className={`mt-4 text-base leading-relaxed ${light ? "text-slate-300" : "text-[#4B5563]"}`}>{subtitle}</p>}
  </div>
);
